

<template>
<div>
<!-- <mu-container> -->
<mu-paper :z-depth="1" class="demo-loadmore-wrap" >
  <mu-appbar color="primary">
    <mu-button icon slot="left">
      <mu-icon value="menu"></mu-icon>
    </mu-button>
    捷胜在线门票
    <mu-button icon slot="right" @click="fullscreen()">
      <mu-icon value="refresh"></mu-icon>
    </mu-button>
  </mu-appbar>
  <mu-text-field v-model="search" placeholder="请输入门店......" style="width: 100%; max-width: 100%;height:48px;" icon="search"></mu-text-field>

  <mu-container ref="container" class="demo-loadmore-content">
    <mu-load-more @refresh="refresh" :refreshing="refreshing" :loading="loading" @load="load" >
      <mu-list toggle-nested style="width:100%;">
        <template v-for="i in num">
     <mu-list-item button :ripple="false" nested :open="open === i" @toggle-nested="open = arguments[0] ? 'stared' : ''">
      <mu-list-item-action>
        <mu-icon value="grade"></mu-icon>
      </mu-list-item-action>
      <mu-list-item-title>Stared</mu-list-item-title>
      <mu-list-item-action>
        <mu-icon class="toggle-icon" size="24" value="keyboard_arrow_down"></mu-icon>
      </mu-list-item-action>
      <mu-list-item button :ripple="false" slot="nested" >
        <mu-list-item-title>List Item 1</mu-list-item-title>
      </mu-list-item>
      <!-- <mu-list-item button :ripple="false" slot="nested">
        <mu-list-item-title>List Item 2</mu-list-item-title>
      </mu-list-item>
      <mu-list-item button :ripple="false" slot="nested">
        <mu-list-item-title>List Item 3</mu-list-item-title>
      </mu-list-item> -->
    </mu-list-item>
          <mu-divider />
        </template>
      </mu-list>
    </mu-load-more>
  </mu-container>
</mu-paper>


  <mu-bottom-nav :value.sync="shift" shift style="position:fixed; bottom:0; width: 100%;">
    <mu-bottom-nav-item value="movies" title="Movies" icon="ondemand_video"></mu-bottom-nav-item>
    <mu-bottom-nav-item value="music" title="Music" icon="music_note"></mu-bottom-nav-item>
    <mu-bottom-nav-item value="books" title="Books" icon="books"></mu-bottom-nav-item>
    <mu-bottom-nav-item value="pictures" title="Pictures" icon="photo"></mu-bottom-nav-item>
  </mu-bottom-nav>
<!-- </mu-container> -->

</div>
</template>


<script>
import 'typeface-roboto'
export default {
       data(){

           return {
            //    微信官方参数
               code:'',
               state:'',

               //刷新 和下拉新增
                     refreshing: false,
                     loading: false,
                       text: 'List',
                     num: 10,

            search:'',
            open: 'send',
            shift: 'movies'
           }
       },
       methods:{

         //刷新
               fullscreen () {
                   const loading = this.$loading();
                      setTimeout(() => {
                   loading.close();
                      }, 2000)
                 },
            //  refresh(){
            //    console.log('refresh');
            //          this.refreshing = true;
            //           // this.$refs.container.scrollTop = 0;
            //            setTimeout(() => {
            //          this.refreshing = false;
            //           this.text = this.text === 'List' ? 'Menu' : 'List';
            //           this.num = 10;
            //          }, 2000)
            //     },
              load () {
                         this.loading = true;
                         setTimeout(() => {
                         this.loading = false;
                          this.num += 10;
                         }, 2000)
                   }

       },

       mounted() {
            this.code=this.$route.query.code;
            this.state=this.$route.query.state;
    
        }

}
</script>
<style scoped >

.demo-list-wrap {
  width: 100%;
  max-width: 100%;

  overflow: hidden;
}

.demo-loadmore-wrap {
  width: 100%;
  max-width: 100%;
  height: 620px;
  display: flex;
  flex-direction: column;

}
  .mu-appbar {
    width: 100%;
  }
.demo-loadmore-content {
  flex: 1;
   width: 100%;
  max-width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>





// WEBPACK FOOTER //
// OAuth.vue?628bddaf